import * as THREE from 'three';

export default class Menu {
    constructor(teleports) {
        this.teleports = teleports
        this.placeholders = this.teleports.placeholders;

        document.addEventListener("placeholderClicked", (event) => {
            if (event.detail.placeholder.location) {
                const element = document.querySelectorAll(`.point-${event.detail.placeholder.id}`)[0]
                for (const specificLocation of this.placeholders) {
                    if (specificLocation.location) {
                        const el = document.querySelectorAll(`.point-${specificLocation.id}`)[0]
                        el.classList.remove('selected')
                    }
                }

                element.classList.add('selected')

            }
        })

        this.setupEventListener()
    }

    setupEventListener() {
        // Handle click
        for (const location of this.placeholders) {
            if (location.location) {
                const element = document.querySelectorAll(`.point-${location.id}`)[0]
                element.addEventListener('click', (event) => {
                    for (const specificLocation of this.placeholders) {
                        if (specificLocation.location) {
                            const el = document.querySelectorAll(`.point-${specificLocation.id}`)[0]
                            el.classList.remove('selected')
                        }
                        // console.log(this.specificLocation.id)
                        // specificLocation.id.classList.remove('selected')
                    }

                    element.classList.add('selected')
                })
            }
        }
    }
}